'use strict'

// Returns the flight summary for outbound or inbound trips
function FlightSummary(bound, origin, destination, departure, arrival, layovers) {
    return `
        <ul class='summary-list'>
            <li class='summary-list-item'>
                <p class='flight-summary-iata'> ${origin} </p>
                <p class='flight-summary-time'> ${departure.time} </p>
            </li>
            <li class='summary-list-item' style='margin-left: 35px'>
                <img class='flight-arrow'
                    src='../../assets/images/plane-black-out.png'
                    style='transform: ${(bound === 'in') ? 'scaleX(-1)' : ''}'>
                </img>
            </li>
            <li class='summary-list-item'>
                <p class='flight-summary-iata'>${destination}</p>
                <p class='flight-summary-time'> ${arrival.time} </p>
            </li>
            <li class='flight-stops'>
                ${layovers === 1 ? `${layovers} stop` : `${layovers} stops`}
            </li>
        </ul>
    `;
}

export default FlightSummary



// WEBPACK FOOTER //
// ./components/FlightSummary.js